/**
 * Created by mac on 12/23/20
 */

const FruitView = cc.Node.extend({
    ctor: function (fruit) {
        this._super();
        this.fruit = fruit;

        if (cleverapps.gameModes.hideFruitParticlesAnimation) {
            return;
        }

        this.restoreState();
        cleverapps.effects.preload(this.getStartEvents());
        cleverapps.effects.preload(this.getCompleteEvents());
    },

    restoreState: function (animated) {
        if (!this.fruit.unit.isBuilt()) {
            return;
        }

        if (cleverapps.silentIntro) {
            animated = false;
        }

        this.createGrowthAnimation();

        if (this.fruit.isGrowing()) {
            this.startGrowth(animated);
        } else {
            this.completeGrowth(animated);
        }
    },

    createGrowthAnimation: function () {
        if (this.animation) {
            return;
        }

        let json = bundles.fruit.jsons.fruit_animation_json;
        if (this.fruit.unit.getType() === "resource") {
            json = bundles.fruit.jsons.castle_animation_json;
        } else if (this.fruit.unit.getType() === "drgenerator") {
            json = bundles.fruit.jsons.generator_animation_json;
        }

        this.animation = new cleverapps.Spine(json);
        this.addChild(this.animation);
    },

    getStartEvents: function () {
        const unit = this.fruit.unit;
        return [
            `unit.fruit.start.${unit.code}`,
            `unit.fruit.start.${unit.getType()}`
        ];
    },

    getCompleteEvents: function () {
        const unit = this.fruit.unit;
        return [
            `unit.fruit.complete.${unit.code}`,
            `unit.fruit.complete.${unit.getType()}`
        ];
    },

    startGrowth: function (animated) {
        if (cleverapps.config.demoMode) {
            return;
        }

        this.animation.setAnimation(0, "growing", true);

        if (animated) {
            cleverapps.effects.fire(this.getStartEvents());
        }
    },

    completeGrowth: function (animated) {
        if (cleverapps.config.demoMode) {
            return;
        }

        if (!animated) {
            this.animation.setAnimation(0, "ready", true);
            return;
        }

        this.animation.setAnimationAndIdleAfter("blink", "ready");
        cleverapps.effects.fire(this.getCompleteEvents());
    }
});